import React from 'react'
import { CreateSupportAnnounce4Container } from '../../containers/Officer/CreateSupportAnnounce4Container'
export const CreateSupportAnnounce4Page = () => {
    return (
        <CreateSupportAnnounce4Container />
    )
}
